import { GlobalAxios } from "./../axios/axios-config";
import { INewBanList, IBanList } from "../models/ban-list";

const TICKET_SERVICE_BAN_LIST_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketServiceBanList/";

export const createBanList = (item: INewBanList) => {
  return GlobalAxios.post(TICKET_SERVICE_BAN_LIST_ROUTE, item);
};

export const getBanListById = (id: string) => {
  return GlobalAxios.get<IBanList>(TICKET_SERVICE_BAN_LIST_ROUTE + id);
};

export const updateBanListById = ({
  item,
  id,
}: {
  item: INewBanList;
  id: string;
}) => {
  return GlobalAxios.put(TICKET_SERVICE_BAN_LIST_ROUTE + id, item);
};
